export const usersLogsSelector = ({ usersLogs }) => usersLogs;
